// extracted by mini-css-extract-plugin
var _1 = "ClientBundlesTableHeaderRow_bundleCell__VCwRu";
var _2 = "ClientBundlesTableHeaderRow_clientCell__7nghE";
var _3 = "ClientBundlesTableHeaderRow_serviceCell__5m+dc";
export { _1 as "bundleCell", _2 as "clientCell", _3 as "serviceCell" }
